import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import eadReadAction from './eadReadCompany.action.json'

const eadReadCompanyDefinition = defineReadAutoAction(eadReadAction, 'empresa')

export default eadReadCompanyDefinition
